import { useTranslation } from 'next-i18next';
import React from 'react';

import { HistoryMeta } from '@/api/asset/asset-schema';
import { formatNumberWithUnit } from '@/utils/asset/assetUtils';

import * as S from './PastEpisodesCard.styles';

interface MedianDataInterface {
  title: string;
  value: number;
}

interface PastEpisodeCardProps {
  metaData: HistoryMeta;
}

export const PastEpisodesCard = ({ metaData }: PastEpisodeCardProps) => {
  const { t } = useTranslation('common');

  const medianData: MedianDataInterface[] = [
    {
      title: t('table.oneWeek'),
      value: metaData.medians.w1,
    },
    {
      title: t('table.twoWeek'),
      value: metaData.medians.w2,
    },
    {
      title: t('table.oneMonth'),
      value: metaData.medians.m1,
    },
  ];

  return (
    <S.PastEpisodesCard data-testid="past-episodes-card">
      <S.PastEpisodesLabel>
        {t('table.pastEpisodes', { count: metaData?.count })}
      </S.PastEpisodesLabel>
      <S.MedianCard>
        {medianData.map((d, i) => (
          <div key={i}>
            <S.MedianTitle>
              {d.title} {t('table.median')}
            </S.MedianTitle>
            <S.MedianValue isPositive={d.value > 0}>
              {formatNumberWithUnit(d.value)}
            </S.MedianValue>
          </div>
        ))}
      </S.MedianCard>
    </S.PastEpisodesCard>
  );
};
